<template>
  <generic-modal :title="$t('update remaining hours')" ref="generic_modal">
    <div>
      <div class="title is-5 mb-0">{{ member.name }}</div>
      <div class="subtitle is-6 has-text-info">
        {{ member.remaining_hours }} {{ $t("hours remaining") }}
      </div>
      <div class="field">
        <label class="label">{{ $t("new remaining hours") }}</label>
        <input class="input" type="text" v-model="meta.remaining_hours" />
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_date,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "Pilates_memberModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      member: {},
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.remaining_hours || isNaN(v.meta.remaining_hours);
    },
  },
  methods: {
    format_date,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(member) {
      let v = this;
      v.set_initial_state();
      v.member = member;
      v.meta.pilates_member_id = member.pilates_member_id;
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      post("/pilates_member/membership-expiration", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.member = {};
      v.meta = {
        name: "",
        pilates_member_id: "",
        remaining_hours: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
